export const TICKETS_COLUMNS = [
  { id: 'event', label: 'Event', alwaysVisible: true },
  { id: 'date', label: 'Date' },
  { id: 'venue', label: 'Venue' },
  { id: 'age_restriction', label: 'Age Restriction', defaultHidden: true },
  { id: 'tickets_sold', label: 'Tickets sold' },
  { id: 'gross', label: 'Gross' },
  { id: 'artist_guarantee', label: 'Artist Guarantee', defaultHidden: true },
  { id: 'actions', label: 'Actions', alwaysVisible: true, pinnedLast: true },
];
